import { sendDelete, sendGet, sendPost, sendPut } from "./axios";

export const getListExtension = (params) => sendGet("/extensions", params);
export const createExtension = (params) => sendPost("/extensions", params);

export const updateExtension = (id, params) =>
  sendPut(`/extensions/${id}`, params);

export const deleteExtension = (id) => sendDelete(`/extensions/${id}`);